import Axios from "axios";
import {GET_PRATICAL_SHEETS, savePraticalSheets} from "../actions/sheets";
import {getApiBaseUrl} from "../utils/baseUrl";
import {setErrorApiMessage} from "../actions/apiFlag";

// On définit par défaut un TimeOut Axios à 10 seconde au bout desquelles un code erreur "ECONNABORTED" est envoyé (code que l'on peut .catch dans une promesse)
// et qui permet donc de définir un message d'erreur en cas de non réponse de l'API
Axios.defaults.timeout = 1000000;

const sheets = (store) => (next) => (action) => {
    switch (action.type) {
        case GET_PRATICAL_SHEETS : {
            const url = `${getApiBaseUrl()}/getFichesPratiques/`;
            Axios.post(url)
                .then((res) => {
                    //Sauvegarde des fiches pratiques dans le store
                    store.dispatch(savePraticalSheets(res.data.listFichesPratiques));
                })
                .catch((err) => {
                    if (err) {
                        if (err.code === "ECONNABORTED") {
                            store.dispatch(setErrorApiMessage(true));
                        }
                        setTimeout(() => {
                            store.dispatch(setErrorApiMessage(false));
                        }, 5000);
                    }
                });
        }
            next(action);
            break;
        default:
            next(action);
    }
};

export default sheets;